import React from 'react'
import styled from 'styled-components';

const Tags = (props) => {

    const {data, isBlur} = props
    if( data === undefined){ return null }
    // console.log(tags)
    return (
        <TagsWrap>
            {data.map(tag =>{
                return (
                    <Tag isBlur={isBlur}>#{tag}</Tag>
                )
            })}
        </TagsWrap>
    )
}
export default Tags;

const TagsWrap = styled.div`
    margin: 10px -5px 0 -5px;
    background-color: #fff;
`
const Tag = styled.div` 
    /* display: inline-flex; */
    display: inline-flex;
    word-break: break-all;
    align-items: center;
    height: auto;
    padding: 0 7px;
    margin: 0 5px;
    font-size: 12px;
    font-weight: 300;
    color: #fff;
    border-radius: 10px;
    background-color: rgba(222, 6, 6, .5);
    ${({ isBlur }) => isBlur ? 'filter: blur(5px)' : ''};
`


// WEBPACK FOOTER //
// ./src/Info/Creator/Tags.js